$(function () {
    $.ajaxSetup({
        headers: {
            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
        },
    });

    $(".required .help").each(function () {
        $(this).prepend(" <span style='color:red;'>*</span>");
    });

    $("body").on("change", ".country_select", function () {
        var $country_select = $(this);
        var code = $(this).val();

        var myState = $(this).data("mystate");
        $(this).data("mystate", null);

        if ($.trim(code) != "") {
            $.get(`/get-state-options/${code}?small=1`, function (data) {
                if (!myState) {
                    myState =
                        $country_select.closest("form").find("input.state_select").val() || $country_select.closest("form").find("select.state_select").val();
                }
                var container = $country_select.closest("form").find(".state_select").parent();
                container.find(".state_select").remove();
                container.append(data);
                container.find("select.state_select").select2();
                if ($.trim(myState) != "") {
                    var selected = $country_select.closest("form").find(".state_select").val(myState).change().val();
                    if (selected === null) {
                        $country_select.closest("form").find(".state_select").val("").change();
                    }
                    $country_select.closest("form").find(".state_text").val(myState);
                }
            });
        }
    });
    $(".country_select").select2();
    setTimeout(() => $(".country_select").trigger("change"), 100);

    function getAddressByValue(id, addressArray) {
        for (var i = 0; i < addressArray.length; i++) {
            if (addressArray[i].id == id) {
                return addressArray[i];
            }
        }
        return -1;
    }

    if ($(".country_select").length > 0) {
        try {
            loadGoogleMaps();
        } catch (e) {
            console.warn(e);
            gm_authFailure();
        }
    }

    $(".long-value-input").on("click", function () {
        $(this).prop("readonly", "");
        $(this).focus();
    });

    // internet explorer requires readonly to be set to display ellipsis
    $(".long-value-input").on("blur", function () {
        $(this).prop("readonly", "readonly");
    });

    $("body").on("change", "#samebilling", function () {
        if (this.checked) {
            if (!$("select[name=address_id]").length || $("select[name=address_id]").val() == 0) {
                $("input[name=first_name]").val(window.customer.first_name);
                $("input[name=last_name]").val(window.customer.last_name);
                $("input[name=name]").val(window.customer.first_name + " " + window.customer.last_name);
                $("input[name=address]").val(window.customer.address);
                $("input[name=city]").val(window.customer.city);
                $("input[name=zip]").val(window.customer.zip);
                $("input[name=state]").val(window.customer.state);
                $("select[name=state]").val(window.customer.state).change();
                $("select[name=country]").val(window.customer.country).change();
                if (typeof stripe !== "undefined" && typeof stripe.zip !== "undefined") {
                    stripe.zip.update({ value: window.customer.zip });
                }
                if (typeof card !== "undefined" && card && typeof card.configure === "function") {
                    card.configure({ postalCode: window.customer.zip });
                }
                if (typeof mountPaymentElements === "function") {
                    mountPaymentElements(window.customer.country, window.customer.zip);
                }
            } else {
                if (window.addresses != 0) {
                    var addressId = $("select[name=address_id]").val();
                    var address = getAddressByValue(addressId, window.addresses);
                    if (address != -1) {
                        $("input[name=first_name]").val(address.first_name);
                        $("input[name=last_name]").val(address.last_name);
                        $("input[name=name]").val(address.first_name + " " + address.last_name);
                        $("input[name=address]").val(address.address);
                        $("input[name=city]").val(address.city);
                        $("input[name=zip]").val(address.zip);
                        $("input[name=state]").val(address.state);
                        $("select[name=state]").val(address.state).change();
                        $("select[name=country]").val(address.country).change();
                        if (typeof stripe !== "undefined" && typeof stripe.zip !== "undefined") {
                            stripe.zip.update({ value: address.zip });
                        }
                        if (typeof card !== "undefined" && card && typeof card.configure === "function") {
                            card.configure({ postalCode: address.zip });
                        }
                        if (typeof mountPaymentElements === "function") {
                            mountPaymentElements(address.country, address.zip);
                        }
                    }
                }
            }
        } else {
            $("input[name=first_name]").val("");
            $("input[name=last_name]").val("");
            $("input[name=name]").val("");
            $("input[name=address]").val("");
            $("input[name=city]").val("");
            $("input[name=zip]").val("");
            $("input[name=state]").val("");
            $("select[name=state]").val("").change();
            $("select[name=country]").val("").change();
            if (typeof stripe !== "undefined" && typeof stripe.zip !== "undefined") {
                stripe.zip.update({ value: "" });
            }
            if (typeof card !== "undefined" && card && typeof card.setPostalCode === "function") {
                card.configure({ postalCode: "" });
            }
            if (typeof mountPaymentElements === "function") {
                mountPaymentElements();
            }
        }
    });

    // Datepicker
    $("#datetimepicker").datetimepicker({
        format: "YYYY-MM-DD H:mm",
        formatTime: "H:mm",
        formatDate: "YYYY-MM-DD",
        minDate: "-1970/01/01", // now
    });
});

/**
 * Used for tooltips on graph
 * @param  string label Series Label
 * @param  float x     x position
 * @param  float y     y position
 * @return string      HTML
 */
function getTooltip(label, x, y, type, priceFormat, singularUnit, pluralUnits, displayTime) {
    if (label == "Trend") {
        return "";
    }
    var date = new Date(x);

    var day = new Date(date.getTime()).getUTCDate();
    var month = new Date(date.getTime()).getUTCMonth() + 1;
    var year = date.getUTCFullYear();
    var value = y.toFixed(2);
    var units = "";

    if (typeof type !== "undefined") {
        chartType = type;
    }
    if (typeof singularUnit == "undefined") {
        singularUnit = "";
    }
    if (typeof pluralUnits == "undefined") {
        pluralUnits = "";
    }
    if (value >= 0.99 && value <= 1.01) {
        units = singularUnit;
    } else {
        units = pluralUnits;
    }

    //used to format value in tooltip (global variable that gets set on page ie. var chartType = 'money'; )
    if (typeof chartType !== "undefined") {
        if (chartType == "count") {
            value = y.toFixed(0);
        }
        if (chartType == "money") {
            value = priceFormat.replace("0.00", y.toFixed(2));
        }
        if (chartType == "decimal") {
            value = y.toFixed(2);
        }
    }

    var html =
        "<div class='flotTip_inner'><div style='font-weight:bold;font-size:0.9rem;text-align:center;'>" + label + "</div><hr style='margin:5px; padding:0;'>";
    html = html + "<span style='font-weight:bold; font-size:17px; color: #24ba7e;'>" + value + units;
    if (typeof displayTime !== "undefined" && displayTime == "true") {
        html += " on " + month + "/" + day + "/" + year;
    }
    html += "</span><br></div>";
    return html;
}

// Datepicker
$(".datepicker").datepicker({
    autoclose: true,
    orientation: "left top",
    format: "yyyy-mm-dd",
});

$(".line_graph").bind("plothover", function (event, pos, item) {
    if (item) {
        $(".flotTip").css({ opacity: 1 });
    }
});

function bootboxConfirmInvoice(msg, action) {
    bootbox.confirm(msg, function (result) {
        if (result) {
            setTimeout(function () {
                $(".invoice_options").html("<div style='padding:40px;text-align:center;'><img src='/images/loading.gif'><br>Processing...Please wait.</div>");
            }, 500);
            action();
        }
    });
}

$(function () {
    // FIXME: this workaround replaces even more broken code. The correct solution
    // is fixing the CSS, but it's a site-wide change that will require re-testing all
    // the subpages in all the supported desktop and mobile browsers.
    (function () {
        var previousHeight = -1;

        function updateLayoutHeight() {
            var currentHeight = document.body.scrollHeight;

            if (currentHeight == previousHeight) return;

            $("#sidebar-black").height(currentHeight);
            $("#wrapper #content").outerHeight(currentHeight);

            previousHeight = currentHeight;
        }

        updateLayoutHeight();
        setInterval(updateLayoutHeight, 500);
    })();

    parseDatatables();

    $("form input[type=submit],form button[type=submit]").each(function () {
        if ($(this).data("disable") === "no") {
            return;
        }
        if ($(this).closest("form").find("input[type=text]").length || $(this).closest("form").find("select").length) {
            $(this).prop("disabled", true);
        }
    });

    $("form input,form select").change(function () {
        $(this).closest("form").find("button[type=submit]").prop("disabled", false);
        $(this).closest("form").find("input[type=submit]").prop("disabled", false);
    });

    $(document).on("keyup", "body", function () {
        $("input[type=submit]").prop("disabled", false);
    });

    $(document).on("click", ".btn", function () {
        if ($(this).attr("data-wait") === "yes") {
            var old = $(this);
            // console.log(old.attr('class'));
            setTimeout(function () {
                old.hide().after(
                    "<input type='button' class='waiting " +
                        old.attr("class") +
                        "' value='" +
                        (window.pw_translations.please_wait ? window.pw_translations.please_wait : "Please Wait...") +
                        "'>",
                );
            });

            setTimeout(function () {
                $(".waiting").remove();
                old.show();
            }, 7000);
        }
    });
});

function enableSubmits() {
    $("button[type=submit]").prop("disabled", false);
    $("input[type=submit]").prop("disabled", false);
}

function acceptLargeQty() {
    $("select[name=quantity]").on("change", function () {
        if ($(this).val() == "more") {
            var frm = $(this).closest("form");
            $(this).replaceWith('<input type="text" name="quantity" id="new_plan_quantity" class="form-control">');
            frm.validate({
                rules: {
                    quantity: {
                        required: true,
                        number: true,
                        min: 1,
                    },
                },
            });
        }
    });
    $("input[name=quantity]")
        .closest("form")
        .validate({
            rules: {
                quantity: {
                    required: true,
                    number: true,
                    min: 1,
                },
            },
        });
}

function gm_authFailure() {
    $("input[name=address]").prop("disabled", false).attr("placeholder", "").removeClass("gm-err-autocomplete").css("background-image", "");
    if (typeof google !== "undefined" && typeof google.maps !== "undefined") {
        google.maps.event.clearInstanceListeners($("input[name=address]")[0]);
    }
    console.warn("Google maps failed to load!");
}

function loadGoogleMaps() {
    if (typeof window.google === "undefined" || typeof window.google.maps === "undefined") {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src =
            "https://maps.googleapis.com/maps/api/js?key=" + window.GOOGLE_API_KEY + "&libraries=places&types=regions&language=en&callback=googleMapsLoaded";
        document.body.appendChild(script);
    } else {
        googleMapsLoaded();
    }
}

function googleMapsLoaded() {
    if (!window.allow_autocomplete) {
        return;
    }

    var $input = $("input[name=address]");
    if ($input.length == 0) {
        return;
    }

    var autocomplete = new google.maps.places.Autocomplete($input[0]);
    autocomplete.setFields(["address_components", "name"]);
    autocomplete.setComponentRestrictions({ country: window.available_countries });
    google.maps.event.addListener(autocomplete, "place_changed", function ($res) {
        var place = autocomplete.getPlace();
        var data = place.address_components;
        var sublocality_level_1 = null;
        var city = null;
        var pc = null;
        var region = null;
        var country = null;
        $.each(data, function (val) {
            if (data[val].types[0] == "sublocality_level_1") {
                sublocality_level_1 = data[val].long_name;
            }
            if (data[val].types[0] == "locality") {
                city = data[val].long_name;
            }
            if (data[val].types[0] == "postal_code") {
                pc = data[val].long_name;
            }
            if (data[val].types[0] == "country") {
                country = data[val].short_name;
            }
            if (data[val].types[0] == "administrative_area_level_1") {
                region = data[val].long_name;
            }
        });
        if (!sublocality_level_1) {
            sublocality_level_1 = "";
        }
        $input.val(place.name + " " + sublocality_level_1);
        $("input[name=city]").val(city);
        $("input[name=zip]").val(pc).focus();
        $(".country_select").data("mystate", region).val(country).trigger("change");
        if (typeof stripe !== "undefined" && typeof stripe.zip !== "undefined") {
            stripe.zip.update({ value: pc });
        }
    });
}

// Keep in sync with resources/scripts/merchant/lib/payment-form.js (it's where the checkPaymentFormCommon() call ends in the merchant app)
function checkPaymentFormCommon() {
    const subscriptionPolicyForm = document.getElementById("subcription-policy-form");
    if (subscriptionPolicyForm && !subscriptionPolicyForm.reportValidity()) {
        return false;
    }
    $("#checkout_button").hide(); // for the widget checkout page
    $("#checkout_loading").show(); // for the widget checkout page
    return true;
}

window._paywhirlLoaded = true;
